<template>
  <el-drawer :title="drawerTitle" :visible.sync="localVisible" direction="rtl" size="700px" append-to-body>
    <div class="drawer-wrap">
      <div v-if="loading" class="drawer-loading">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
      <div v-else-if="!dataList.length" class="drawer-empty">
        <i class="el-icon-document"></i>
        <div>暂无地区数据</div>
      </div>
      <template v-else>
        <el-row :gutter="12" class="stat-row">
          <el-col :span="unFinishCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num">{{ dataList.length }}</div>
              <div class="stat-label">共计条目</div>
            </div>
          </el-col>
          <el-col :span="unFinishCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num success">{{ finishCount }}</div>
              <div class="stat-label">已完成</div>
            </div>
          </el-col>
          <el-col :span="8" v-if="unFinishCount > 0">
            <div class="stat-card">
              <div class="stat-num danger">{{ unFinishCount }}</div>
              <div class="stat-label">未完成</div>
            </div>
          </el-col>
        </el-row>
        <div v-for="item in dataList" :key="item.areaId" class="dict-item">
          <div class="dict-cell">
            <div class="dict-cell-key">地区名称</div>
            <div class="dict-cell-val">
              {{ item.areaName }}
            </div>
          </div>
          <div class="dict-cell">
            <div class="dict-cell-key">状态</div>
            <div class="dict-cell-val">
              <el-tag :type="item.status === '1' ? 'success' : 'danger'" size="small">
                {{ item.status === '1' ? ' 已完成' : '未完成' }}
              </el-tag>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { listForestArea } from '@/api/forest/area'

export default {
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      localVisible: false,
      loading: false,
      dataList: []
    }
  },
  computed: {
    drawerTitle() {
      return this.row.provinceName + '包含地区'
    },
    finishCount() {
      return this.dataList.filter(r => r.status === '1').length
    },
    unFinishCount() {
      return this.dataList.filter(r => r.status === '0').length
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
    },
    localVisible(val) {
      this.$emit('update:visible', val)
      if (val) {
        this.loadData()
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    loadData() {
      if (!this.row || !this.row.provinceId) return
      this.loading = true
      this.dataList = []
      listForestArea({ provinceId: this.row.provinceId, size: 100, current: 1 }).then(response => {
        this.dataList = response.rows || []
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.dict-item {
  grid-template-columns: 1fr 1fr;
}
.dict-cell {
  grid-template-columns: 80px 1fr;
}
</style>
